import { FC } from 'react';
import { useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import PhotoXsWebp from '#srcImages/main-background/style-red/photo-xs.webp';
import PhotoSmWebp from '#srcImages/main-background/style-red/photo-sm.webp';
import PhotoWebp from '#srcImages/main-background/style-red/photo.webp';
import { BackgroundImage } from '#home/components';
import homeBackgroundCss from '#home/components/background/assets/home-background.module.scss';

const BackgroundImageDefaultStyleRed: FC = () => {
  const isFrontendStyleRed = useIsFrontendStyleRed();

  if (!isFrontendStyleRed) {
    return null;
  }

  return (
    <picture>
      <source
        media="(max-width: 799px)"
        srcSet={`${PhotoXsWebp} 1x, ${PhotoSmWebp} 2x, ${PhotoWebp} 3x`}
      />
      <BackgroundImage src={PhotoWebp} additionalClassName={homeBackgroundCss.homeBackground__image_styleRed} />
    </picture>
  );
};

export { BackgroundImageDefaultStyleRed };
